import { Dashboard, DashboardResponsiveApiModelSparse } from 'src/shared/models/dashboard.model';
import { cloneDeep } from 'lodash';

export class DashboardProjectionSettingsModel {
    public loadedDashboards: string[] = [];
    public selectedDashboards: string[] = [];
    public loadedDashboardObjects: DashboardResponsiveApiModelSparse[] = [];
    public selectedDashboardObjects: DashboardResponsiveApiModelSparse[] = [];
    public useAutoSwipe = false;

    public rawMinutesInput: string | number = '';
    public rawSecondsInput: string | number = '';

    public savingAllowed = true;

    public temp: DashboardProjectionSettingsModel = null;

    /** Copies the settings into the settings.temp field for use in the dialog. This allows altering settings without affecting the current projection */
    public copyToTemp() {
        this.temp = new DashboardProjectionSettingsModel();
        //this.temp.autoSwipeDelay = this._formatDelayText(this.autoSwipeDelay);
        this.temp.loadedDashboards = this._copyValue(this.loadedDashboards) ?? [];
        this.temp.selectedDashboards = this._copyValue(this.selectedDashboards) ?? [];
        this.temp.useAutoSwipe = this._copyValue(this.useAutoSwipe) ?? false;
        this.temp.rawMinutesInput = this._copyValue(this.rawMinutesInput) ?? '';
        this.temp.rawSecondsInput = this._copyValue(this.rawSecondsInput) ?? '';
        this.temp.selectedDashboardObjects = cloneDeep(this.selectedDashboardObjects);
        this.temp.loadedDashboardObjects = cloneDeep(this.loadedDashboardObjects);
    }

    /** Copies the settings from the settings.temp field for use in the dialog.
     * Since the .temp values are changing, need to copy them back to the primary fields when a dialog is 'saved'
     */
    public copyFromTemp() {
        //this.autoSwipeDelay = this._parseDelayText(this.temp.autoSwipeDelay);
        this.loadedDashboards = this._copyValue(this.temp.loadedDashboards);
        this.selectedDashboards = this._copyValue(this.temp.selectedDashboards);
        this.useAutoSwipe = this._copyValue(this.temp.useAutoSwipe);
        this.rawMinutesInput = this._copyValue(this.temp.rawMinutesInput);
        this.rawSecondsInput = this._copyValue(this.temp.rawSecondsInput);
        this.selectedDashboardObjects = cloneDeep(this.temp.selectedDashboardObjects);
        this.loadedDashboardObjects = cloneDeep(this.temp.loadedDashboardObjects);
    }

    private _copyValue(field: any) {
        if (typeof(field) !== 'undefined')
            return JSON.parse(JSON.stringify(field));
        else return null;
    }

    public copyForSave() {
        const copy = new DashboardProjectionSettingsModel();
        copy.loadedDashboards = this._copyValue(this.loadedDashboards);
        copy.selectedDashboards = this._copyValue(this.selectedDashboards);
        copy.useAutoSwipe = this._copyValue(this.useAutoSwipe);
        copy.rawMinutesInput = this._copyValue(this.rawMinutesInput);
        copy.rawSecondsInput = this._copyValue(this.rawSecondsInput);
        return copy;
    };
}
